<template>
  <div class="report-check">
    <div class="data-content">
      <div class="table-head">
        <div class="table-title">
          <span style="font-weight: bold;margin-left: 20px;">成衣铺销量统计</span>
          <Select @on-query-change="typeChanged" v-model="filterData.local_type" :clearable="false"
            style="width: 80px; margin-left: 20px; margin-right: 20px;">
            <Option v-for="item in filterData.localType" :value="item.value" :key="item.value">{{item.label }}
            </Option>
          </Select>
          <Button @click="getData()">搜索</Button>
        </div>
       
      </div>
      <div style="display: flex;width: 100%;">
        <span style="font-weight: bold;margin-left: 20px; color: #bbbbbb;margin-top: 10px;">Tips: 销量数据为最近30天</span>
      </div>
      <div style="width: 100%; display: flex;">
        <div class="report-content">
          <Table stripe border highlight-row :columns="columns" :data="changeDataList" @on-selection-change="selected"
            :height="tableHeight">
            <template slot-scope="{ row, index }" slot="figure_image_id">
              <span>{{ row.figure_image_id }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="url">
              <Poptip trigger="hover" :transfer="true" title="图片详情">
                <div class="info-pop" slot="content">
                  <img :src="row.url">
                </div>
                <img :src="row.url" style="width: 80px;height: 80px;">
              </Poptip>
            </template>

            <template slot-scope="{ row, index }" slot="pay_price">
              <span>{{ row.pay_price }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="count">
              <span>{{ row.count }}</span>
            </template>
          </Table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import apis from "../../http/api";

  export default {
    name: "AnalyseList",
    components: {},
    watch: {},
    data() {
      return {
        tableHeight: 400,
        filterData: {
          keyword: null,
          local_type: 1,
          localType: [{
            'label': 'Co币',
            'value': 0
          }, {
            'label': 'Co钻',
            'value': 1
          }],
        },
        dataList: [],
        columns: [{
            title: '商品ID',
            slot: 'figure_image_id',
            align: 'center',
            width: 120
          },
          {
            title: '商品图',
            slot: 'url',
            align: 'center',
            width: 120,
          },
          {
            title: '售价',
            slot: 'pay_price',
            align: 'center',
            width: 120
          },
          {
            title: '销量',
            slot: 'count',
            align: 'center',
            width: 120
          },
          {
            title: ' ',
            slot: 'empty',
            align: 'center',
            width: 0
          },
        ],
      }
    },
    created() {
      this.tableHeight = window.innerHeight - 150
      window.addEventListener('resize', this.handleResize);
      this.getData()
    },
    methods: {
      handleResize() {
        this.tableHeight = window.innerHeight - 150
      },
      typeChanged(options) {
        this.getData()
      },
      getData() {
        let params = {
          pay_type: this.filterData.local_type
        };
        apis.image_shop_sell_recently(params).then(res => {
          const {
            data,
            errCode,
            msg
          } = res;
          if (errCode === 0) {
            console.log('test info  =', data)
            this.dataList = data;
          } else {
            this.$Message.error(msg);
            this.dataList = null
          }
        }).catch(err => {
          this.$Message.error('接口异常,请联系管理员');
          this.dataList = []
        })
      },
      dateChange(data) {
        this.getData()
      },
      toResetUseInfo(key, row, content) {

      },
      selected(selecttion) {
        console.log(selecttion.id)
      },
    },
    computed: {
      changeDataList() {
        return this.dataList.map(item => {
          // item['date'] = item['date'].replace(/\s.*$/, '');
          // var categoryName = '[[安卓&苹果]]'
          // switch (item.category) {
          //   case 2:
          //     categoryName = '安卓'
          //     break
          //   case 1:
          //     categoryName = '苹果'
          //     break
          //   default:
          //     categoryName = '[安卓&苹果]'
          //     break
          // }
          // item['category_name'] = categoryName

          return item
        })
      }
    },
    filters: {}
  }
</script>

<style scoped>
  .report-check {
    margin: 10px;
  }

  .clickable-span {
    color: #1890ff;
    text-decoration: underline;
    cursor: pointer;
  }

  .text-center {
    text-align: center;
  }

  .table-head {
    display: flex;
    justify-content: space-between;
    padding-bottom: 5px;
  }

  .table-title {
    align-self: center;
  }

  .modal1-div {
    margin-bottom: 10px;
  }

  .info-pop {
    white-space: pre-wrap;
  }

  .avatar {
    float: left;
    width: 50px;
    margin-top: 20px;
    margin-right: 15px;
  }

  .img-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid lightgray;
  }

  .img-avatar-preview {
    width: 400px;
    height: 400px;
  }

  .report-content {
    float: left;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20px;
  }

  .report-table-td-title {
    width: 95px;
    color: #333333;
    /* font-size: 18px; */
    padding-left: 5px;
    padding-right: 5px;
    vertical-align: top;
  }

  .report-table-td-content {
    width: 360px;
    color: #333333;
    /* font-size: 18px; */
    padding-left: 5px;
    padding-right: 5px;
  }

  table,
  th,
  td {
    border: 2px solid transparent;
    border-collapse: collapse;
  }

  table,
  td {
    height: auto;
  }

  .report-button {
    font-size: 12px;
    margin-left: 5px;
    width: 100px;
    height: 22px;
    margin-right: 5px;
  }

  .report-button-other {
    font-size: 12px;
    margin-left: 5px;
    width: 100px;
    height: 22px;
    margin-right: 5px;
    background-color: #fff;
    /* border-color: #f90; */
    border: 0.5px solid #ff9900;
    color: #f90;
  }
</style>